import {BaseAlert, BaseBadge, BaseButton, BaseCard} from "@/components";
import {useRaffles} from "./useRaffles";

const formatDate = (value: string): string => {
  if (!value) return "";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  return d.toLocaleDateString("es-VE", {day: "2-digit", month: "short", year: "numeric"});
};

const RafflesPage = () => {
  const {raffles, isLoading, isError, error, refetch} = useRaffles();

  return (
    <section className="mx-auto flex w-full max-w-5xl flex-col gap-6 px-4 py-8">
      <header className="flex flex-col gap-2">
        <h1 className="text-[var(--font-h1)] font-bold text-[var(--color-text)]">Rifas</h1>
        <p className="text-[var(--font-body-lg)] text-[var(--color-text-secondary)]">
          Participa en los próximos sorteos y gana premios increíbles.
        </p>
      </header>

      {isLoading ? (
        <BaseCard
          variant="surface"
          padding="lg"
        >
          <p className="text-center text-[var(--font-body-lg)] text-[var(--color-text-secondary)]">Cargando rifas...</p>
        </BaseCard>
      ) : isError ? (
        <BaseAlert
          variant="danger"
          title="No pudimos cargar las rifas"
        >
          <p>{error?.message ?? "Inténtalo nuevamente."}</p>
          <BaseButton
            variant="secondary"
            size="sm"
            onClick={() => refetch()}
          >
            Reintentar
          </BaseButton>
        </BaseAlert>
      ) : raffles.length === 0 ? (
        <BaseCard
          variant="surface"
          padding="lg"
        >
          <p className="text-center text-[var(--font-body-lg)] text-[var(--color-text-secondary)]">
            No hay rifas disponibles en este momento.
          </p>
        </BaseCard>
      ) : (
        <ul className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {raffles.map(raffle => (
            <li key={raffle.id}>
              <BaseCard
                variant="surface"
                padding="none"
                interactive
              >
                {raffle.image ? (
                  <img
                    src={raffle.image}
                    alt={raffle.title}
                    className="h-40 w-full rounded-t-xl object-cover"
                    loading="lazy"
                  />
                ) : null}
                <div className="flex flex-col gap-2 p-4">
                  <div className="flex items-start justify-between gap-2">
                    <h2 className="text-[var(--font-h3)] font-semibold text-[var(--color-text)]">{raffle.title}</h2>
                    {raffle.status ? (
                      <BaseBadge
                        variant={raffle.status === "active" ? "success" : "neutral"}
                        size="sm"
                      >
                        {raffle.status}
                      </BaseBadge>
                    ) : null}
                  </div>
                  {raffle.description ? (
                    <p className="line-clamp-2 text-[var(--font-body)] text-[var(--color-text-secondary)]">
                      {raffle.description}
                    </p>
                  ) : null}
                  <div className="mt-1 flex flex-col gap-1 text-[var(--font-body)] text-[var(--color-text-tertiary)]">
                    {raffle.drawDate ? <span>Sorteo: {formatDate(raffle.drawDate)}</span> : null}
                    {raffle.ticketPrice !== null ? <span>Ticket: {raffle.ticketPrice.toFixed(2)}</span> : null}
                  </div>
                </div>
              </BaseCard>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
};

export default RafflesPage;
